module.exports = __webpack_public_path__ + "static/media/clase.c2bd5c44.png";